var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("FbaJob.BookingAudit"),
        width: "720px",
        "custom-class": "cargo-form-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.handleClose
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "cargo-form",
          attrs: { "label-width": "110px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "auto-width",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.radioType,
                            callback: function($$v) {
                              _vm.radioType = $$v
                            },
                            expression: "radioType"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("FbaJob.UseNewNo")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationCompany")) + "："
                          )
                        ]
                      ),
                      _c("cargo-office-select", {
                        attrs: {
                          clearable: false,
                          disabled: !_vm.job.opOfficeUpdate,
                          "have-hq": false,
                          "office-id": Number(_vm.job.opOffice),
                          tooltip: ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opOffice = p.value
                            _vm.officeChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") + "：" } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          disabled: !_vm.job.opUpdate,
                          "method-params": {
                            officeId: _vm.job.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.job.op || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.op = p.value
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.OperationDepartment")) +
                              "："
                          )
                        ]
                      ),
                      _c("cargo-department-select", {
                        attrs: {
                          "office-id":
                            Number(_vm.job.opOffice) ||
                            _vm.$store.getters.currentOfficeId,
                          "department-id": Number(_vm.job.opDepartment),
                          disabled: !_vm.job.opDepartmentUpdate
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.CustomerService") + "："
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "csr",
                        attrs: {
                          "method-params": {
                            officeId: _vm.job.salesOffice,
                            category: "role",
                            shape: "csr"
                          },
                          disabled: !_vm.job.csrUpdate,
                          "default-value": _vm.job.csr || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.csr = p.value
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v(_vm._s(_vm.$t("FbaJob.ShippingType")) + "：")]
                      ),
                      _c(
                        "el-select",
                        {
                          attrs: {
                            value: _vm.job.shippingType,
                            disabled:
                              !_vm.hasFbaChannel && !_vm.job.shippingTypeUpdate,
                            filterable: ""
                          },
                          on: { change: _vm.changeShippingType }
                        },
                        _vm._l(_vm.FbaJobConstants.SHIPPING_TYPES, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label:
                                _vm.$store.getters.language === "zh"
                                  ? item.chineseName
                                  : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("FbaJob.IncoTerm") + "：" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "incoTerm",
                          disabled: !_vm.job.incoTermUpdate,
                          "select-type":
                            _vm.selectTypeNames.basic_data_IncoTerm,
                          filterable: "",
                          clearable: false,
                          "default-value": _vm.job.incoTerm
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.incoTerm = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("FbaJob.DomesticWarehouse")) + "："
                          )
                        ]
                      ),
                      _c("cargo-company-select", {
                        attrs: {
                          "method-params": { warehouse: true, active: true },
                          disabled: !_vm.job.domesticWarehouseUpdate,
                          "default-value":
                            Number(_vm.job.domesticWarehouse) || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.job.domesticWarehouse = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("FbaJob.overseaWarehouse") + "：" }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "overseaWarehouseCode",
                          disabled: !_vm.job.overseaWarehouseCodeUpdate,
                          "select-type":
                            _vm.selectTypeNames.basic_data_OverseaWarehouse,
                          filterable: "",
                          "method-params": { ifFba: false },
                          clearable: false,
                          "tag-name": "countryChineseName",
                          "tag-value": "warehouseCode",
                          "default-value": _vm.job.overseaWarehouseCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.overseaWarehouseCode = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _vm.job.shippingType === "SE" || _vm.job.shippingType === "RE"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.FLCLType")) + "："
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "containerLoadType",
                              disabled: !_vm.job.containerLoadTypeUpdate,
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$FBA_CONTAINER_LOAD_TYPES,
                              filterable: "",
                              clearable: false,
                              "default-value": _vm.job.containerLoadType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.containerLoadType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.job.shippingType === "AE"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.OperateType")))]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "operateType",
                              disabled: !_vm.job.operateTypeUpdate,
                              clearable: false,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_AirExportConstants$BUSINESS_MODELS,
                              "default-value": _vm.job.operateType
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.operateType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  (_vm.job.shippingType === "SE" ||
                    _vm.job.shippingType === "RE") &&
                  _vm.job.containerLoadType === "LCL"
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("FbaJob.LclMethod") + "：" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.job.lclMethod,
                                callback: function($$v) {
                                  _vm.$set(_vm.job, "lclMethod", $$v)
                                },
                                expression: "job.lclMethod"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "LCL" } }, [
                                _vm._v(_vm._s("自拼箱"))
                              ]),
                              _c("el-radio", { attrs: { label: "BB" } }, [
                                _vm._v(_vm._s("委托拼箱"))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.job.shippingType === "AE"
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "span",
                            {
                              staticClass: "blue",
                              attrs: { slot: "label" },
                              slot: "label"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BookingProperty"))
                              )
                            ]
                          ),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "bookingTerm",
                              disabled: !_vm.job.bookingTermUpdate,
                              filterable: "",
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames.local_cache_BookingTerm,
                              "default-value": _vm.job.bookingTerm,
                              fields: ["chineseName"]
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.bookingTerm = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Remarks") + "：" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          disabled: !_vm.job.remarksUpdate,
                          rows: 2
                        },
                        model: {
                          value: _vm.job.remarks,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "remarks", $$v)
                          },
                          expression: "job.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        {
          staticStyle: { padding: "10px" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }